// extracted by mini-css-extract-plugin
module.exports = {"freedomPhone":"Phone_freedomPhone__3IpBz","svg":"Phone_svg__39GQr","number":"Phone_number__60i-w","white":"Phone_white__2v0MA","blue":"Phone_blue__3iEix"};